import cx from "classnames";
import * as React from "react";

interface QESWidgetHeaderProps {
  className?: string;
}

/**
 * The top of the widget. To be used as a wrapper for the Title and Description components.
 */
export const QESWidgetHeader: React.FC<React.PropsWithChildren<QESWidgetHeaderProps>> = ({
  children,
  className,
}) => {
  return (
    <div className={cx("qes-widget__header", className)}>
      {children}
    </div>
  );
};
